// Globální volba jazyka pro veřejný obsah (CZ výchozí, EN překlad).
import React, { createContext, useContext, useState } from "react";

const Ctx = createContext({ lang: "cs", setLang: () => {} });

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        try { return localStorage.getItem("fa_lang") || "cs"; } catch { return "cs"; }
    });
    const setLang = (l) => {
        try { localStorage.setItem("fa_lang", l); } catch { /* private mode */ }
        setLangState(l);
    };
    return <Ctx.Provider value={{ lang, setLang }}>{children}</Ctx.Provider>;
}

export const useLang = () => useContext(Ctx);
